module.exports = __webpack_public_path__ + "static/media/signup.cf035ba9.svg";